import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from '@mui/material';
import React from 'react';
import { generatePath, NavLink } from 'react-router-dom';

import { ADMIN_CONTRACT_EDIT_URL } from '../../constants/routeUrls';

interface ContractEditPageLinkProps {
  contractId: Number;
  // When true, render the legacy icon-only link (used in tight cells like the contract-list grid).
  compact?: boolean;
}

function ContractEditPageLink({ contractId, compact = false }: ContractEditPageLinkProps) {
  const to = generatePath(ADMIN_CONTRACT_EDIT_URL, { id: contractId.toString() });

  if (compact) {
    return (
      <NavLink to={to}>
        <Tooltip title="Edit Contract" placement="top-end">
          <FontAwesomeIcon icon={faPenToSquare} color="rgba(0, 0, 0, 0.54)" />
        </Tooltip>
      </NavLink>
    );
  }

  return (
    <Button
      component={NavLink}
      to={to}
      variant="contained"
      color="success"
      startIcon={<FontAwesomeIcon icon={faPenToSquare} />}
      sx={{ color: '#fff' }}
    >
      Edit Contract
    </Button>
  );
}

export default ContractEditPageLink;
